<key-layout-view direction="vertical"
    page="status"
    [show]="true"
    [header]="mobileHeader">
    <div key-layout-grid-column-inner
        class="page-card">

        <kui-alert type="danger"
            class="key-alert-wrapper"
            *ngIf="errorMessage">
            <kui-icon name="ban"
                size="sm"></kui-icon>
            <span>{{errorMessage}}</span>
        </kui-alert>

        <div key-content-container
            [ngClass]="{'flex-container': true, 'has-sidebar': isMobile}"
            *ngIf="asset && ready"
            [scroll]="true">

            <!-- <kui-content-header *ngIf="!isFloating && !isMobile && isCompact"
                [title]="asset.name"
                class="tabs-header">
                <kui-content-header-actions>
                    <kui-icon *ngIf="app?.features?.page?.overview?.show?.sharing && asset?.telemetry?.location"
                        class="pl-1"
                        kui-action
                        name="share-square"
                        [title]="'STATUS.DETAILS.SHARE.HINT' | translate"
                        (click)="shareAction('new', '')"></kui-icon>
                    <kui-dropdown *ngIf="actionsMenu && actionsMenu.length > 0"
                        class="pl-1"
                        [style]="'none'"
                        [title]="'STATUS.DETAILS.ACTIONS.HINT' | translate"
                        [menu]="actionsMenu">
                        <kui-icon kui-action
                            name="tasks-alt"></kui-icon>
                    </kui-dropdown>
                    <kui-icon *ngIf="hasCameraIO && !isFloating"
                        class="pl-1"
                        kui-action
                        name="video"
                        [title]="'DIALOG.VIDEO' | translate"
                        (click)="showRequestVideoModal(asset.id)"></kui-icon>
                    <kui-icon *ngIf="asset && asset.telemetry && asset.telemetry.location"
                        class="pl-1"
                        kui-action
                        name="lock"
                        [title]="'STATUS.DETAILS.GEO_LOCK.LOCK' | translate"
                        (click)="geoLockAsset()"></kui-icon>
                    <kui-icon *ngIf="app.features.page.replay.enabled"
                        class="pl-1"
                        kui-action
                        name="history"
                        [title]="'MENU.TRIP_REPLAY' | translate"
                        (click)="openReplay()"></kui-icon>
                    <kui-icon *ngIf="!isMobile"
                        class="pl-1"
                        kui-action
                        name="times"
                        [title]="('DIALOG.CLOSE' | translate) + ' ' + asset.name"
                        (click)="deselectAsset()"></kui-icon>
                </kui-content-header-actions>
            </kui-content-header> -->

            
            <kui-content-header *ngIf="(isCompact || isFloating) && !isMobile"
                [title]="isFloating ? ('STATUS.OVERVIEW.ASSETS' | translate) : ('STATUS.OVERVIEW.DETAILS' | translate)"
                icon="back"
                (action)="deselectAsset()"
                class="tabs-header">
                <kui-content-header-actions>
                    <kui-icon *ngIf="!isMobile"
                        class="pl-1"
                        kui-action
                        name="times"
                        [title]="('DIALOG.CLOSE' | translate) + ' ' + asset.name"
                        (click)="isFloating ? deselectAsset(true) : deselectAsset()"></kui-icon>
                </kui-content-header-actions>
            </kui-content-header>

            <key-details-overview-card *ngIf="!isMobile && location !== 'bottom'"
                class="pb-2"
                [assetId]="asset.id"
                [icon]="getIcon()"
                [badges]="assetBadges">
                <key-details-overview-summary [asset]="asset"
                    [movement]="overviewSummaryMovement"
                    [trip]="overviewSummaryTrip"
                    [allowEditing]="allowEditing"
                    (edit)="editAsset($event)"></key-details-overview-summary>
            </key-details-overview-card>

            <div class="border-width"
                *ngIf="isMobile">
                <key-overview-map style="height: 250px"
                    key-layout-grid-column-inner
                    [assets]="mapAssets"
                    [isMobile]="isMobile"></key-overview-map>
                <div class="ml-0 mr-0 no-border-left-nested no-border-md-right-nested row"
                    *ngIf="asset && asset.telemetry">
                </div>
            </div>

            <div id="tabs"
                class="d-block flex-1 flex-container">
                <kui-content-header class="tabs-header">
                    <kui-tab-bar [items]="tabs"
                        [selected]="activeTab"
                        (selection)="setActiveTab($event)"></kui-tab-bar>
                    <kui-content-header-actions *ngIf="!isCompact || isMobile">
                        <kui-icon *ngIf="app?.features?.page?.overview?.show?.sharing && asset?.telemetry?.location && !isMobile"
                            class="pl-1"
                            kui-action
                            name="share-square"
                            [title]="'STATUS.DETAILS.SHARE.HINT' | translate"
                            (click)="shareAction('new', '')"></kui-icon>
                        <kui-dropdown *ngIf="actionsMenu && actionsMenu.length > 0 && !isMobile"
                            class="pl-1"
                            [style]="'none'"
                            [title]="'STATUS.DETAILS.ACTIONS.HINT' | translate"
                            [menu]="actionsMenu">
                            <kui-icon kui-action
                                name="tasks-alt"></kui-icon>
                        </kui-dropdown>
                        <kui-icon *ngIf="hasCameraIO && !isMobile"
                            class="pl-1"
                            kui-action
                            name="video"
                            [title]="'DIALOG.VIDEO' | translate"
                            (click)="showRequestVideoModal(asset.id)"></kui-icon>
                        <kui-icon *ngIf="asset && asset.telemetry && asset.telemetry.location && !isMobile"
                            class="pl-1"
                            kui-action
                            name="lock"
                            [title]="'STATUS.DETAILS.GEO_LOCK.LOCK' | translate"
                            (click)="geoLockAsset()"></kui-icon>
                        <kui-icon *ngIf="app.features.page.replay.enabled && !isMobile"
                            class="pl-1"
                            kui-action
                            name="history"
                            [title]="'MENU.TRIP_REPLAY' | translate"
                            (click)="openReplay()"></kui-icon>
                        <kui-icon *ngIf="!isMobile"
                            class="pl-1"
                            kui-action
                            name="times"
                            [title]="('DIALOG.CLOSE' | translate) + ' ' + asset.name"
                            (click)="deselectAsset()"></kui-icon>
                    </kui-content-header-actions>
                </kui-content-header>

                <div class="flex-1 flex-container">

                    <div class="overflow-auto position-relative bg-card-block"
                        [ngClass]="{'flex-container': activeTab === 'activity', 'details-container': activeTab === 'activity'}"
                        [hidden]="activeTab !== 'activity'"
                        *ngIf="tabLoadedIndex['activity']">

                        <key-details-sidebar *ngIf="(io.length || fields.length || contacts.length || state.length || telemetry) && !isCompact"
                            [linkedAssets]="linkedAssets"
                            [linkedFrom]="linkedFrom"
                            [ioValues]="io"
                            [fields]="fields"
                            [contacts]="contacts"
                            [state]="state"
                            [telemetry]="telemetry"
                            [geoLock]="geoLock"
                            [geoLockProfile]="geoLockProfile"
                            [tasks]="tasks"
                            [shares]="shares"
                            (userAction)="userAction($event)"></key-details-sidebar>

                        <div class="bg-content details-content no-border">
                            <div class="bg-content details-content__inner">
                                <key-details-overview-card *ngIf="isMobile || (location === 'bottom')"
                                    [assetId]="asset.id"
                                    [icon]="getIcon()"
                                    [badges]="assetBadges">
                                    <key-details-overview-summary [asset]="asset"
                                        [movement]="overviewSummaryMovement"
                                        [allowEditing]="allowEditing"
                                        (edit)="editAsset($event)"
                                        [trip]="overviewSummaryTrip"></key-details-overview-summary>
                                </key-details-overview-card>

                                <div class="my-2"
                                    *ngIf="(io.length || fields.length || contacts.length || state.length || telemetry) && isCompact">
                                    <key-details-sidebar [linkedAssets]="linkedAssets"
                                        [linkedFrom]="linkedFrom"
                                        [ioValues]="io"
                                        [fields]="fields"
                                        [contacts]="contacts"
                                        [state]="state"
                                        [telemetry]="telemetry"
                                        [geoLock]="geoLock"
                                        [geoLockProfile]="geoLockProfile"
                                        [tasks]="tasks"
                                        [shares]="shares"
                                        (userAction)="userAction($event)"></key-details-sidebar>
                                </div>
                                <key-feed *ngIf="app.features.page.overview.show.activity && (location === 'bottom' || isMobile)"
                                    class="mt-1 d-block"
                                    type="trip"
                                    originType="asset"
                                    [id]="asset.id"
                                    [showDetailsModal]="true"
                                    [primaryAction]="app.features.page.replay.enabled ? 'detailsModal' : 'selectItem'"></key-feed>
                            </div>
                        </div>
                    </div>

                    <div class="overflow-auto position-relative"
                        [hidden]="activeTab !== 'trips'"
                        *ngIf="isCompact && tabLoadedIndex['trips'] && app.features.page.overview.show.activity">
                        <key-feed class="d-block"
                            type="trip"
                            originType="asset"
                            [id]="asset.id"
                            [showDetailsModal]="true"
                            [primaryAction]="app.features.page.replay.enabled ? 'detailsModal' : 'selectItem'"></key-feed>
                    </div>

                    <div class="overflow-auto position-relative"
                        [hidden]="activeTab !== 'alerts'"
                        *ngIf="tabLoadedIndex['alerts'] && app.features.page.overview.show.alerts">
                        <key-feed type="alert"
                            originType="asset"
                            [id]="asset.id"
                            [showDetailsModal]="true"
                            primaryAction="detailsModal"></key-feed>
                    </div>

                    <div class="overflow-auto position-relative"
                        [hidden]="activeTab !== 'events'"
                        *ngIf="tabLoadedIndex['events'] && app.features.page.overview.show.events">
                        <key-feed type="event"
                            originType="asset"
                            [id]="asset.id"
                            [showDetailsModal]="true"
                            primaryAction="detailsModal"></key-feed>
                    </div>

                    <div class="overflow-auto position-relative h-100"
                        [hidden]="activeTab !== 'videos'"
                        *ngIf="tabLoadedIndex['videos'] && hasCameraIO">
                        <key-overview-details-video [asset]="asset"
                            [isVisible]="activeTab === 'videos'"></key-overview-details-video>
                    </div>

                    <div class="overflow-auto position-relative h-100"
                        [hidden]="activeTab !== 'tasks'"
                        *ngIf="tabLoadedIndex['tasks']">
                        <key-overview-details-task key-layout-grid-column-inner
                            class="flex-1 list-view w-100 h-100"
                            [asset]="asset"
                            [isVisible]="activeTab === 'tasks'"></key-overview-details-task>
                    </div>

                    <div *ngFor="let p of customPanels"
                        class="h-100 w-100"
                        [hidden]="activeTab !== p.id">

                        <iframe *ngIf="true || tabLoadedIndex[p.id]"
                            class="h-100 w-100"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            [src]="p.url">
                        </iframe>

                    </div>

                </div>

            </div>
        </div>
    </div>
    <div>
        <!-- this creates a footer bar with action buttons for the floating "basic" view -->
        <kui-content-header class="overview-details-footer min-width-0"
            *ngIf="isFloating || isMobile || isCompact">
            <kui-content-header-actions class="pr-2 min-width-0 d-flex justify-right">

                <div kui-action
                    *ngIf="app.features.page.replay.enabled"
                    class="px-1 text-truncate action-history"
                    (click)="openReplay()">
                    <kui-icon name="history"
                        [title]="'MENU.TRIP_REPLAY' | translate"></kui-icon>
                    <span class="action-text text-truncate">{{ 'STATUS.DETAILS.ACTION_BUTTONS.HISTORY' | translate }}</span>
                </div>

                <div kui-action
                    *ngIf="hasCameraIO"
                    class="px-1 text-truncate action-request-videos"
                    (click)="showRequestVideoModal(asset.id)">
                    <kui-icon name="video"
                        [title]="'DIALOG.VIDEO' | translate"></kui-icon>
                    <span class="action-text text-truncate">{{ 'STATUS.DETAILS.ACTION_BUTTONS.REQUEST_VIDEO' | translate }}</span>
                </div>

                <div kui-action
                    *ngIf="asset && asset.telemetry && asset.telemetry.location"
                    class="px-1 text-truncate action-geo-lock"
                    (click)="geoLockAsset()">
                    <kui-icon name="lock"
                        [title]="'STATUS.DETAILS.GEO_LOCK.LOCK' | translate"></kui-icon>
                    <span class="action-text text-truncate">{{ 'STATUS.DETAILS.ACTION_BUTTONS.GEO_LOCK' | translate }}</span>
                </div>

                <div kui-action
                    *ngIf="app?.features?.page?.overview?.show?.sharing && asset?.telemetry?.location"
                    (click)="shareAction('new', '')"
                    class="px-1 text-truncate action-share-location">
                    <kui-icon name="share-square"
                        [title]="'STATUS.DETAILS.SHARE.HINT' | translate"></kui-icon>
                    <span class="action-text text-truncate">{{ 'STATUS.DETAILS.ACTION_BUTTONS.SHARE' | translate }}</span>
                </div>

                <div kui-action
                    *ngIf="actionsMenu && actionsMenu.length > 0"
                    class="px-1 text-truncate action-actions">
                    <kui-dropdown class="text-truncate"
                        [style]="'none'"
                        [title]="'STATUS.DETAILS.ACTIONS.HINT' | translate"
                        [menu]="actionsMenu">
                        <kui-icon kui-action
                            name="tasks-alt"></kui-icon>
                        <span class="action-text text-truncate">{{ 'STATUS.DETAILS.ACTION_BUTTONS.ACTIONS' | translate }}</span>
                    </kui-dropdown>
                </div>

            </kui-content-header-actions>
        </kui-content-header>
    </div>
</key-layout-view>